/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter module for return an array of numbers in the provided range.
 */
angular
  .module('filters.range', [])
  /**
   * Filter used to return an array of numbers in the provided range.
   *
   * @param {Array} input - The source array.
   * @param {Number} min - The number in the lower bound.
   * @param {Number} max - The number in the upper bound.
   *
   * @returns {Array} An array containing the numbers in the range.
   */
  .filter('range', function () {
    return function (input, min, max) {
      min = parseInt(min, 10);
      max = parseInt(max, 10);
      input = _.range(min, max);
      return input;
    };
  });
